import request from '@/utils/request';
export const fetchCustomerImg = (paramMap) => {
	return request({
		url: '/proFileApi/customer/getService',
		method: 'get',
		params: paramMap,
        responseType: 'blob'
	})
}